export const environment = {
  production: false,
  environmentName: 'sportisimo-dev',
  dirPrefix: 'sportisimo'
};
